import React from 'react';

const DeviceContext = React.createContext({});

export default DeviceContext;
export const DeviceProvider = DeviceContext.Provider;
export const DeviceConsumer = DeviceContext.Consumer;